import React, { useEffect, useState } from "react";
import FormatDateTime from "../../utils/formatDateTime";
import {
  ChevronsUpDownIcon,
  Edit2Icon,
  PlusIcon,
  Trash2Icon,
} from "lucide-react";
import { Button } from "../../components/ui/button";
import apiClient from "../../utils/apiClient";
import { EditCallPutModal } from "./EditCallPutModal";
import { AddCallPutModal } from "./AddCallPutModal";
import server from "../../utils/serverConfig";

const StocksScreenerTable = ({ data, isDataUpdated, setIsDataUpdated }) => {
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedData, setSortedData] = useState([]);

  // Function to handle sorting
  const handleSort = (field) => {
    // If a new column is clicked, reset to descending order
    setSortOrder((prevSortOrder) => {
      const newSortOrder = prevSortOrder === "asc" ? "desc" : "asc";

      // Sort the data based on the field and the new sortOrder
      const sorted = [...data].sort((a, b) => {
        const aValue = a[field];
        const bValue = b[field];

        if (aValue < bValue) return newSortOrder === "asc" ? -1 : 1;
        if (aValue > bValue) return newSortOrder === "asc" ? 1 : -1;
        return 0;
      });

      setSortedData(sorted);
      return newSortOrder;
    });
  };

  useEffect(() => {
    // Initial sorting when data is first loaded or changed
    const sorted = [...data].sort((a, b) => {
      const aValue = a.call; // Default to sorting by "call" column
      const bValue = b.call;

      if (aValue < bValue) return sortOrder === "asc" ? -1 : 1;
      if (aValue > bValue) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sorted);
  }, [data]);

  const handleRemoveSymbolFromList = (symbol) => {
    console.log("Removed Symbol  from List", symbol);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}delete-stock-symbol`,
      data: {
        stockSymbol: symbol,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        setIsDataUpdated(!isDataUpdated);
      })
      .catch((error) => {
        console.log(error);
        setIsDataUpdated(!isDataUpdated);
      });
  };

  const handleAddSymbolToList = (stockSymbol, callValue, putValue) => {
    console.log("Symbol to be added  to List", stockSymbol);

    console.log("Call value", callValue);
    console.log("Removed Symbol  from List", putValue);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}add-stock-symbol`,
      data: {
        stockSymbol: stockSymbol,
        callValue: callValue,
        putValue: putValue,
      },
    };

    if (!stockSymbol) {
      return alert("Please select a stock symbol");
    }

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        setIsDataUpdated(!isDataUpdated);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUpdateCallPutValue = (stockSymbol, newCallValue, newPutValue) => {
    console.log("Symbol to be updated ", stockSymbol);

    console.log("New CALL value", newCallValue);
    console.log("New PUT value", newPutValue);

    if (newCallValue === 0 && newPutValue === 0) {
      handleRemoveSymbolFromList(stockSymbol);
      setIsDataUpdated(!isDataUpdated);
      return;
    }

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-call-put`,
      data: {
        stockSymbol: stockSymbol,
        callValue: newCallValue,
        putValue: newPutValue,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        setIsDataUpdated(!isDataUpdated);
      })
      .catch((error) => {
        console.log(error);
        setIsDataUpdated(!isDataUpdated);
      });
  };

  return (
    <div className="z-0 w-full font-poppins h-[calc(100vh-60px)] border-t-[1px] border-gray-800 custom-scroll overflow-x-auto shadow-md animate-reveal transition-all duration-500 ease-in">
      <table className="bg-black text-sm w-full relative z-0">
        <thead className="sticky top-0 bg-[#0F0F0F] text-sm text-left">
          <tr className="text-white border-b border-gray-800">
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              S.No
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Symbol
              <ChevronsUpDownIcon
                onClick={() => handleSort("symbol")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Updated At
              <ChevronsUpDownIcon
                onClick={() => handleSort("updated_at")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Sources
              <ChevronsUpDownIcon
                onClick={() => handleSort("sources")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="text-center border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              CALL
              <ChevronsUpDownIcon
                onClick={() => handleSort("call")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="text-center border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              PUT
              <ChevronsUpDownIcon
                onClick={() => handleSort("put")}
                className="h-4 w-4 text-white cursor-pointer inline-block ml-1"
              />
            </th>
            <th className="text-center border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData && sortedData.length > 0 ? (
            sortedData.map((ele, i) => (
              <tr
                key={i}
                className={`text-white border-b border-gray-800 ${
                  ele.call === 1 || ele.put === 1 ? "bg-yellow-900" : ""
                }`}
              >
                <td className="px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {i + 1}
                </td>
                <td className="px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.symbol}
                </td>
                <td className="px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {FormatDateTime(ele.updated_at)}
                </td>
                <td className="px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  <div className="w-full space-x-2">
                    {ele.sources.map((source, index) => (
                      <span
                        key={index}
                        className={`${
                          source?.value === "External"
                            ? "bg-orange-600"
                            : source?.source === "screener_tag"
                            ? "bg-gray-600"
                            : "bg-blue-600"
                        } text-white text-[11px] px-2 py-[2px] rounded-[4px]`}
                      >
                        {source?.value}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="text-center px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.call}
                </td>
                <td className="text-center px-4 py-1 text-[14px] border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {ele.put}
                </td>
                <td className="px-4 py-1 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  <div className="flex items-center space-x-4 justify-center">
                    {ele.call === 0 && ele.put === 0 ? (
                      <AddCallPutModal
                        symbol={ele["Underlying scrip code"]}
                        call={ele.call}
                        put={ele.put}
                        handleAddSymbolToList={handleAddSymbolToList}
                      />
                    ) : (
                      <EditCallPutModal
                        symbol={ele["Underlying scrip code"]}
                        call={ele.call}
                        put={ele.put}
                        handleUpdateCallPutValue={handleUpdateCallPutValue}
                      />
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="7"
                className="px-4 py-20 text-center text-white text-[20px] font-medium"
              >
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default StocksScreenerTable;
